import { ContractActionV1Dto } from '@/openapi/models/ContractActionV1Dto';

export enum Priority {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  UNKNOWN = 'unknown',
}

export function getPriority(value: string | null | undefined): Priority {
  if (!value) return Priority.UNKNOWN;
  const formattedValue = value.toLowerCase();

  switch (formattedValue) {
    case 'high':
      return Priority.HIGH;
    case 'medium':
      return Priority.MEDIUM;
    case 'low':
      return Priority.LOW;
    default:
      return Priority.UNKNOWN;
  }
}

export const getPriorityTagSeverity = (priority: Priority) => {
  switch (priority) {
    case Priority.HIGH:
      return 'danger';
    case Priority.MEDIUM:
      return 'warn';
    case Priority.LOW:
      return 'success';
    default:
      return 'secondary';
  }
};

export const getStatusTagSeverity = (status?: ContractActionV1Dto.status) => {
  if (!status) return 'secondary';
  switch (status) {
    case ContractActionV1Dto.status.COMPLETED:
      return 'secondary';
    case ContractActionV1Dto.status.ACTIVE:
      return 'warn';
    case ContractActionV1Dto.status.AVAILABLE:
      return 'success';
    default:
      return 'secondary';
  }
};
